import { createSelector } from 'reselect';

export const bookmakersListSelector = ({ bookmakersList }) => bookmakersList;

export const createBookmakerInfoSelector = feedSelector => createSelector(
    [feedSelector, bookmakersListSelector],
    (selectedFeed, bookmakers) => bookmakers.find(({ feed }) => selectedFeed === feed) || null,
);

export const createUserInfoSelector = feedSelector => createSelector(
    createBookmakerInfoSelector(feedSelector),
    bookmakerInfo => (!!bookmakerInfo && bookmakerInfo.userInfo) || {},
);

export const createIsLoggedInSelector = feedSelector => createSelector(
    createBookmakerInfoSelector(feedSelector),
    bookmakerInfo => !!bookmakerInfo && bookmakerInfo.isLoggedIn,
);

export const createBookmakerApiNameSelector = feedSelector => createSelector(
    createBookmakerInfoSelector(feedSelector),
    bookmakerInfo => (!!bookmakerInfo && bookmakerInfo.apiName) || '',
);

export const createFreeBetsEnabledSelector = feedSelector => createSelector(
    createBookmakerInfoSelector(feedSelector),
    bookmakerInfo => !!bookmakerInfo && bookmakerInfo.freeBetsEnabled,
);



// WEBPACK FOOTER //
// /src/js/common/bookmakersList/bookmakersList.selectors.js